export const TAGS = [
  'Heart',
  'Lung',
  'Stomach',
  'Spleen',
  'Liver',
  'Gallbladder',
  'Large Intestine',
  'Small Intestine',
  'Triple Burner',
  'Kidney',
  'Bladder',
  'Pericardium',
];

export const tagToColor: Record<string, string> = {
  Heart: 'rgb(255, 107, 107)',
  Lung: 'rgb(77, 150, 255)',
  Stomach: 'rgb(255, 195, 0)',
  Spleen: 'rgb(241, 111, 81)',
  Liver: 'rgb(58, 252, 155)',
  Gallbladder: 'rgb(46, 196, 182)',
  'Large Intestine': 'rgb(247, 127, 0)',
  'Small Intestine': 'rgb(200, 160, 255)',
  'Triple Burner': 'rgb(230, 57, 70)',
  Kidney: 'rgb(184, 255, 143)',
  Bladder: 'rgb(255, 178, 224)',
  Pericardium: 'rgb(255, 59, 160)',
};
